import { Button } from "@shared/ui/button";
import {
  Bell,
  Circle,
  Clock11,
  FileText,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { OutstandingSummary } from "../summary";
import { OutstandingCurrentList } from "../list";

const OutstandingLandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="page-title">Outstanding Accounts</h1>
          <p className="page-subtitle">Manage and analyze outstanding account balances and collection activities.</p>
        </div>
        <div className="flex gap-3">
          <Button
            variant="destructive"
            onClick={() => { navigate('/cx/outstanding/create/bulk-reminder') }}
          >
            <Bell className="h-4 w-4" />
            Bulk Reminders
          </Button>
          <Button
            variant="default"
            onClick={() => { navigate('/cx/outstanding/create/bulk-notice') }}
          >
            <FileText className="h-4 w-4" />
            Bulk Notice
          </Button>
          <Button
            variant="outline"
            onClick={() => { navigate('/cx/outstanding/audit-trail') }}
          >
            <Clock11 className="h-4 w-4" />
            Audit Trail
          </Button>
        </div>
      </div>

      <OutstandingSummary />

      <OutstandingCurrentList />
    </div>
  );
};

export default OutstandingLandingPage;
